// extracted by mini-css-extract-plugin
export default {"player-box":"index_player-box__1tUZU"};